import apiClient from '../axios.js'

async function uploadWebsiteImageVia(presignPath, file) {
  const urlRes = await apiClient.post(presignPath, {
    fileName: file.name,
    fileType: file.type,
    fileSize: file.size,
  })
  const payload = urlRes?.data?.data || urlRes?.data || {}
  const { presignedUrl, objectKey, fileUrl } = payload
  if (!presignedUrl || !fileUrl) {
    throw new Error(urlRes?.data?.message || urlRes?.message || '無法取得上傳 URL')
  }

  await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', presignedUrl)
    xhr.setRequestHeader('Content-Type', file.type)
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve()
      else reject(new Error(`圖片上傳失敗（HTTP ${xhr.status}）`))
    }
    xhr.onerror = () => reject(new Error('圖片上傳失敗：網路連線錯誤'))
    xhr.send(file)
  })

  return { success: true, data: { fileUrl, objectKey } }
}

export const websiteSeoService = {
  list: () => apiClient.get('/website/seo'),
  get: (pageKey) => apiClient.get(`/website/seo/${encodeURIComponent(pageKey)}`),
  update: (pageKey, data) => apiClient.put(`/website/seo/${encodeURIComponent(pageKey)}`, data),
  syncRegistry: () => apiClient.post('/website/seo/sync-registry'),

  /** OG Image：預簽名 URL 直傳 S3（相容 ImageUploader uploadFn） */
  uploadImage: (file) => uploadWebsiteImageVia('/website/seo/upload-url', file),
}

export const websiteBlogService = {
  list: (params = {}) => apiClient.get('/website/blog-posts', { params }),
  get: (id) => apiClient.get(`/website/blog-posts/${id}`),
  create: (data) => apiClient.post('/website/blog-posts', data),
  update: (id, data) => apiClient.put(`/website/blog-posts/${id}`, data),
  remove: (id) => apiClient.delete(`/website/blog-posts/${id}`),

  /** 封面／OG 圖：預簽名 URL 直傳 S3（相容 ImageUploader uploadFn） */
  uploadImage: (file) => uploadWebsiteImageVia('/website/blog-posts/upload-url', file),
}

export const websiteContactService = {
  list: (params = {}) => apiClient.get('/website/contact-inquiries', { params }),
  get: (id) => apiClient.get(`/website/contact-inquiries/${id}`),
  update: (id, data) => apiClient.patch(`/website/contact-inquiries/${id}`, data),
  remove: (id) => apiClient.delete(`/website/contact-inquiries/${id}`),
}
